module.exports = __webpack_public_path__ + "media/promo/velle/images/logo-0b1e25727e9da6057da8380eafe47efe.svg";